var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectleft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 98,
    viewBox: "0 0 64 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 33.0652C0.5 29.9723 2.28286 27.1565 5.07865 25.8338L37.5498 10.471C42.3127 8.21765 47.9154 11.104 48.8455 16.2903L61.7279 88.1193C62.6351 93.1776 58.6061 97.767 53.473 97.5225L8.11948 95.3628C3.85397 95.1597 0.5 91.6422 0.5 87.3719V33.0652Z",
    fill: "#1B1717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 30.0652C0.75 27.069 2.47714 24.3411 5.18557 23.0597L37.6568 7.69703C42.2708 5.51406 47.6984 8.31023 48.5995 13.3344L61.4818 85.1635C62.3607 90.0636 58.4576 94.5096 53.4849 94.2728L8.13137 92.1131C3.99916 91.9163 0.75 88.5088 0.75 84.3719V30.0652Z",
    fill: "#404043",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.0652C1 24.1656 2.67143 21.5258 5.29249 20.2857L37.7637 4.92301C42.2288 2.81046 47.4814 5.51643 48.3534 10.3785L61.2358 82.2076C62.0863 86.9497 58.3091 91.2523 53.4968 91.0231L8.14326 88.8634C4.14435 88.673 1 85.3753 1 81.3719V27.0652Z",
    fill: "#232222",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 28.5973C3.25 25.6176 4.95829 22.9018 7.64413 21.6116L36.4103 7.79264C41.0361 5.57046 46.5054 8.3767 47.398 13.4303L59.0111 79.1774C59.876 84.0739 55.9715 88.5066 51.005 88.2664L10.6257 86.3141C6.49584 86.1144 3.25 82.7078 3.25 78.5731V28.5973Z",
    fill: "url(#paint0_linear_9071_7551)",
    stroke: "#18790C",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9071_7551",
    x1: 30,
    y1: 11,
    x2: 32,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133817"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectleft);
export default __webpack_public_path__ + "static/media/rectleft.cfd91c41a79dd07f22f83d261b229fa4.svg";
export { ForwardRef as ReactComponent };